import { Box } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Drawer from '../../../components/Drawer/Drawer';
import { reset, setStep } from '../../../stores/ImportStore';
import { RootState } from '../../../stores/Store';
import ImportErrorsStep from './ImportErrorsStep';
import ImportSummaryStep from './ImportSummaryStep';

interface ImportDrawerProps {
  open: boolean;
  onClose: () => void;
}

function ImportDrawer({ open, onClose }: ImportDrawerProps) {
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const { step } = useSelector((state: RootState) => state.importReducer);
  const NUMBER_OF_STEPS = 2;
  const [progress, setProgress] = useState(100 / NUMBER_OF_STEPS);

  /**
   * Handle the close action
   */
  const handleClose = () => {
    dispatch(reset());
    onClose();
  };

  /**
   * Handle the back button of the drawer to close or to go back a step
   */
  const handleBackButton = () => {
    if (step === 1) {
      handleClose();
    } else if (step === 3 || step === 4) {
      dispatch(setStep(1));
    } else {
      dispatch(setStep(step - 1));
    }
  };

  React.useEffect(() => {
    setProgress((step / NUMBER_OF_STEPS) * 100);
  }, [step]);

  /**
   * Render each step of the upgrade device journey
   */
  const renderSteps = () => {
    switch (step) {
      case 1:
        return <ImportErrorsStep onClose={handleClose} />;
      case 2:
        return <ImportSummaryStep onClose={handleClose} />;
      default:
        return null;
    }
  };

  return (
    <Drawer
      disablePortal
      open={open}
      onClose={handleClose}
      onBackButton={handleBackButton}
      anchor="right"
      title={t('pages.import.importDrawer.title')}
      progress={progress}
    >
      <Box sx={{ paddingTop: '2rem', height: '100%' }}>{renderSteps()}</Box>
    </Drawer>
  );
}

export default ImportDrawer;
